<style lang="scss">
.relation-title{
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #ff9900;
    color: #fff;
}
</style>

<template>
    <div>
        <div class="bg-fff margin-top-20 padding-bottom-20" >
            <header class="relation-title font-bold">关联订单</header>
            <Table
            class="margin-10"
            :columns="columns" 
            :data="formList"
            size="small" 
            ref="table"  
            border 
            stripe></Table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: [ 'comreleVance', 'type', 'status', 'parentId','nodeId'],
    data() {
        return {
            // isSuper: this.$store.state.userinfo.isSuper,
            // isParentid: this.$route.query.nodeid,
        }
    },
    created(){
        
    },
    methods:{
        handleOperate(data){
            let routeData = this.$router.resolve({
                name: 'b2cOrderupdate',
                params: { type: 'query' },
                query: { id: data}
            });
            window.open(routeData.href, '_blank');
        }
    },
    computed:{
        formList(){
            return this.comreleVance || []
        },
        columns() {
            const _this = this;
            return [{
                title: '父订单号',
                key: 'shipperName',
                render(h, { row }) {
                    if(_this.nodeId!='0'){
                        return <div>
                            <a onClick={_this.handleOperate.bind(this, row.parentId)}>{row.parentId}/{row.parentNo}</a>
                        </div>
                    }else{
                        return <div>{row.parentId}/{row.parentNo}</div>
                    }
                }
            }, {
                title: '子订单号',
                key: 'shipperContactName',
                render(h, { row }) {
                    if(_this.nodeId=='0'){
                        return <div>
                            <a onClick={_this.handleOperate.bind(this, row.itemId, row.parentId)}>{row.itemId}/{row.itemNo}</a>
                        </div>
                    }else{
                        return <div>{row.itemId}/{row.itemNo}</div>
                    }
                }
            }, {
                title: '关联订单状态',
                key: 'factoryName',
                render(h, { row }) {
                    switch (row.orderStatus) {
						case 'pending': return <div class="b2cspan-error" size='small'>未支付</div>; break;
						case 'unshipped': return <div class="b2cspan-middle-content" size='small'>未发货</div>; break;
						case 'approved': return <div class="b2cspan-success" size='small'>已审核</div>; break;
						case 'assigned': return <div class="b2cspan-primary" size='small'>已分配</div>; break;
						case 'picked': return <div class="b2cspan-info" size='small'>已配货</div>; break;
						case 'shipped': return <div class="b2cspan-light-content" size='small'>已发货</div>; break;
						case 'canceled': return <div class="b2cspan-warning" size='small'>已取消</div>; break;
						case 'refunded': return <div tclass="b2cspan-dark-primary" size='small'>已退款</div>; break;
					}
                }
            }, {
                title: '关联原因',
                key: 'factoryContactName',
                render(h, { row }) {
                    // switch (row.cause) {
						// case 'baseInfo': return <div type='primary' size='small'>-</div>; break;
						// case 'celebrity': return <div type='primary' size='small'>红人订单</div>; break;
						// case 'sample': return <div type='primary' size='small'>样品订单</div>; break;
						// case 'reshipment': return <div type='primary' size='small'>补发订单</div>; break;
						// case 'addition': return <div type='primary' size='small'>附加订单</div>; break;
						// case 'dismantlement	': return <div type='primary' size='small'>拆解订单</div>; break;
                    // }
                    return <div>{row.cause}</div>
                }
            },{
                title: '是否回传父订单',
                key: 'factoryContactName',
                render(h, { row }) {
                    switch (row.isAllowTracking) {
						case 'nothing': return <div type='primary' size='small'>是</div>; break;
						case 'allow': return <div type='primary' size='small'>允许</div>; break;
						case 'unAllow': return <div type='primary' size='small'>不允许</div>; break;
					}
                }
            },]
        },
    },

}
</script>

